import { useEffect, useRef } from 'react';
import { authServiceInstance } from '@/services/authServiceInstance';

const RefreshThreshold = 5 * 60 * 1000; // 5 minutes

/**
 * This hook runs a background process that:
 * - Checks the current auth token expiration every minute
 * - Automatically refreshes the token when it has RefreshThreshold (5 minutes) or less remaining
 */
export const useAutoTokenRefresh = () => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const checkAndRefreshToken = async () => {
    try {
      const session = authServiceInstance.getCurrentSession();
      if (!session?.tokens) return;

      const timeUntilExpiry = session.tokens.expires_at - Date.now();

      if (timeUntilExpiry > RefreshThreshold) return;

      await authServiceInstance.refreshTokens();
    } catch (error) {
      console.error('Token refresh failed:', error);
    }
  };

  useEffect(() => {
    checkAndRefreshToken();
    intervalRef.current = setInterval(checkAndRefreshToken, 60 * 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);
};
